module.exports = __webpack_public_path__ + "media/icons/linkedin-blue-228cd5b9.svg";